import { EnrichedVideoEditorEditListItemDto } from '@app/modules/video-editions/types';

/** Poll interval while at least one edit has `renderJob.isPending`. */
export const VIDEO_EDITIONS_EDIT_LIST_REFETCH_MS = 5000;

/**
 * Returns the refetch interval for an edits list query while any render job is pending.
 */
export function getVideoEditionsEditListRefetchInterval(
  edits: EnrichedVideoEditorEditListItemDto[] | undefined,
): number | false {
  if (!edits?.length) return false;
  return edits.some((edit) => edit.renderJob?.isPending === true)
    ? VIDEO_EDITIONS_EDIT_LIST_REFETCH_MS
    : false;
}
